import {Action} from "@ngrx/store";
import {IActivity} from '../../activities/activity';

export const UPDATE_ONGOING_ACTIVITY: string = '[ongoing activity] Update Ongoing Activity';

export class UpdateOngoingActivity implements Action {

  readonly type: string = UPDATE_ONGOING_ACTIVITY;
  constructor(public payload: IActivity | null) {}

}

export type OngoingActivityAction = UpdateOngoingActivity;
